import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GetGift } from '../gift-voucher.interface';
import { getMembers } from '../../member/member.interface';
import { AlertService } from 'src/app/services/alert.service';
import { AppURL } from 'src/app/app.url';


@Component({
  selector: 'app-send-gift-voucher',
  templateUrl: './send-gift-voucher.component.html',
  styleUrls: ['./send-gift-voucher.component.scss']
})
export class SendGiftVoucherComponent {
  voucherId: string = ""
  constructor(private http: HttpClient,
    private ac: ActivatedRoute,
    private alert: AlertService,
    private router: Router
  ) {
    this.voucherId = this.ac.snapshot.params['id']
    if (this.voucherId) {
      this.findVoucher();
      this.getMemberItems();
      this.getRankItems()
    }
  }

  voucherItem!: GetGift
  findVoucher() {
    this.http.get(`gift/${this.voucherId}`).subscribe({
      next: (res: any) => {
        this.voucherItem = res.data
      }
    })
  }
  findMember: string = ""
  memberItems!: getMembers[]
  memberFindItems!: getMembers[]
  getMemberItems() {
    this.http.get(`member?search=${this.findMember}&page=1&limit=1000000`).subscribe({
      next: (res: any) => {
        this.memberItems = res.data;
        if (this.memberItems == null) this.memberFindItems = Object.assign([])
        else {
          this.memberItems.forEach(f => f.Select = false)
          this.memberFindItems = Object.assign(this.memberItems)
        }

      }
    })
  }

  rankItems: any
  getRankItems() {
    this.http.get(`rank`).subscribe({
      next: (res: any) => {
        this.rankItems = res.data
      }
    })
  }

  selectMemberAll: boolean = false
  selectAll() {
    this.selectMemberAll = !this.selectMemberAll
    this.memberFindItems.forEach(f => f.Select = this.selectMemberAll)
  }

  selectMember(item: getMembers) {
    item.Select = !item.Select
  }

  findRank(rank: any) {
    let filterItems = this.memberItems.filter(fl => fl.Rank_name == rank.RankName)
    if (filterItems) {
      this.memberFindItems = Object.assign(filterItems)
      this.selectMemberAll = false
      this.memberFindItems.forEach(f => f.Select = false)
    }
  }

  memberListSend: getMembers[] = []
  sendToList() {
    let filterMember = this.memberFindItems.filter(fl => fl.Select == true)
    if (this.memberListSend.length == 0) {
      filterMember.forEach(f => this.memberListSend.push(f))
    }
    else {
      filterMember.forEach(f => {
        if (!this.memberListSend.find(fn => fn == f)) this.memberListSend.push(f)
      })
    }

    this.viewVoucher = true

  }

  deleteMemberSend(item: getMembers) {
    this.memberListSend.splice(this.memberListSend.findIndex(del => del == item), 1)
  }

  viewVoucher: boolean = false
  voucherAmount: string = ''
  sendVoucher() {
    let model = {
      VoucherId: this.voucherId,
      VoucherAmount: parseInt(this.voucherAmount),
      MemberList: this.memberListSend
    }

    this.http.post(`gift/send-voucher`, model).subscribe({
      next: (res: any) => {
        this.alert.notify('ส่งบัตรกำนัลเรียบร้อย', 'success')
        this.router.navigate(['/', AppURL.gift])
      },
      error: (err) => {
        this.alert.notify(err.error.message, 'warning')
      }
    })
  }

  removeAll() {
    this.memberListSend = []
  }



}
